<template>
  <PoolRow
    :label="$t('common.myDeposit')"
    @click="isShowPooledInfo = !isShowPooledInfo"
  >
    <img
      :class="[isShowPooledInfo ? 'dropdown-img_active' : 'dropdown-img']"
      src="@/assets/pools/dropdown.svg"
    />
  </PoolRow>

  <template v-if="isShowPooledInfo">
    <PoolRow :label="$t('pools.poolBalance')">
      <template v-if="!poolsStore.loaders.addedFundsLoader">
        <PoolBalance :is-version-v1="isVersionV1" :pool="pool" />
      </template>
      <Skeleton v-else width="70px" height="30px" />
    </PoolRow>

    <PoolRow
      v-if="!isVersionV1"
      :label="$t('common.lpBalance')"
      :value="`${lpToLabel(pool?.lp || 0)} ${$t('common.lp')}`"
    />

    <PoolRow :label="$t('common.usdValue')" :value="getUSDAmount(pool)" />
  </template>
</template>
<script lang="ts" setup>
import { ITablePool, ITablePoolV1 } from '@/types/pools';
import { ref, toRefs } from 'vue';
import { getUSDAmount, lpToLabel } from '@/composables/usePoolsTableServices';
import { usePoolsStore, useTablePoolStore } from '@/store';
import { PoolRow } from '../PoolRow';
import { VERSION_1 } from '@/constants';
import { PoolBalance } from '@/components/Pools/Table';

interface IProps {
  pool: ITablePool | ITablePoolV1;
}
const props = defineProps<IProps>();
const { pool } = toRefs(props);
const poolsStore = usePoolsStore();
const isShowPooledInfo = ref(true);
const tablePoolStore = useTablePoolStore();

const isVersionV1 = tablePoolStore.version === VERSION_1;
</script>

<style lang="scss" scoped src="./style.scss" />
